// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".test-selector[data-v-6f2ef1ad] {\n  max-width: 300px;\n  position: absolute;\n  top: 800px;\n  left: 100px;\n}\n.modal-body p[data-v-6f2ef1ad] {\n  text-align: left;\n}\n.register-page__footer .register-footer.mobile[data-v-6f2ef1ad] {\n  width: 100% !important;\n}", ""]);
// Exports
module.exports = exports;
